export default __webpack_public_path__ + "static/img_3_0-76a9518d5ae440800655aab194fbaef0.jpg";